import {SHOW_SNACK} from "../../constants/action-types";


const initialState = {
    data : {
        show: false
    },
};

const snackReducer = (state = initialState, action) => {

    switch (action.type) {
        case SHOW_SNACK:
            return { ...state, data: {show: action.show, text: action.text, snackType: action.snackType, oldSnackType: state.data.snackType}};
        default:
            return state;
    }
};


export default snackReducer;